import React, { FunctionComponent, useEffect, useState } from "react";

import { Button } from "@material-ui/core";
import { Segment } from "../../../models/Segment";
import useStyles from "./style";
import { DropzoneArea } from "material-ui-dropzone";
import { SaveSegmentDialog } from "./SaveSegmentDialog";
import { Alert } from "@material-ui/lab";

export interface SegmentUploadUsersProps {
  segment: Segment;
  onSave: () => void;
}

export const SegmentUploadUsers: FunctionComponent<SegmentUploadUsersProps> = ({
  segment,
  onSave
}) => {
  const classes = useStyles();

  const [state, setState] = useState({
    saveSegment: false,
    file: null as any
  });

  return (
    <>
      {segment.id && (
        <Alert severity={"info"}>
          Uploading a new file will overwrite the current users in the segment.
        </Alert>
      )}
      <div className={classes.fileUploadArea}>
        <DropzoneArea
          acceptedFiles={["text/csv"]}
          dropzoneText={"Drag and drop a .csv-file with user emails here"}
          showPreviewsInDropzone={true}
          useChipsForPreview
          filesLimit={1}
          onChange={files => {
            setState({
              ...state,
              file: files[files.length - 1]
            });
          }}
        />
      </div>
      <Button
        style={{ width: 200, marginTop: 20 }}
        variant="contained"
        disabled={!state.file}
        color="primary"
        onClick={() => setState({ ...state, saveSegment: true })}
      >
        {segment.id ? "Update segment " : "Create segment "}
      </Button>

      <SaveSegmentDialog
        open={state.saveSegment}
        segmentId={segment.id}
        segmentName={segment.name}
        file={state.file}
        onSave={() => {
          setState({ ...state, saveSegment: false });
          onSave();
        }}
        onCancel={() => setState({ ...state, saveSegment: false })}
      />
    </>
  );
};
